/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

@observer
export default class TermsComponent extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 signin">
                        <hr />
                        <h2 id="">
                            Privacy Policy, General Terms and Conditions of Media Services
                        </h2>
                        Effective: December 2015
                        <hr />
                        <p>
                            deliver.media <br />
                            <strong>SMP Solutions GmbH</strong> <br />
                            Platz 3 <br />
                            CH-6039 Root D4 <br />
                            Switzerland
                        </p>
                        <p>
                            SMP Solutions GmbH further as SMP Solutions or SMPS defines the
                            following services. SMP Solutions are taking the protection of your
                            personal data very seriously. This privacy act declaration governs the
                            storage, processing and disclosure of personal user data by SMP
                            Solutions in accordance with the Swiss Privacy Act. It is valid part in
                            addition and within the scope of SMP Solutions General Business Terms
                            and Conditions.
                        </p>
                        <h3 id="1privacyactobjectiveandresponsibleoffice">
                            1. PRIVACY ACT OBJECTIVE AND RESPONSIBLE OFFICE
                        </h3>
                        <p>
                            This privacy act declaration applies to all services provided by SMP
                            Solutions. Services may include internet websites, as well as (mobile)
                            applications (apps), particularly apps for mobile end devices, smart-TVs
                            (for example Apple TV) and set-top-boxes or streaming-boxes and other
                            applications (software). Unless otherwise indicated, it governs how SMP
                            Solutions handles your personal data exclusively. The office responsible
                            for data processing is SMP Solutions GmbH. If you use third party
                            services, the privacy act provisions of these third parties used shall
                            apply exclusively.
                        </p>
                        <h3 id="2datacollection">2. DATA COLLECTION</h3>
                        <p>
                            During registration, as well as use, certain personal user data is
                            collected and processed. This includes or may include: e-mail address,
                            name, mailing address, payment information, date of birth, gender,
                            language (as a whole, referred to as “personal data), income, education,
                            household, occupation, consumer behavior, hobbies, preferred activities
                            and use of services (all of the above information is referred to
                            hereafter as “relevant personal data”). Within the scope of utilization,
                            additional data such as geo location, IP addresses, browser type and
                            access times from your computer, are transferred to us automatically and
                            stored on our servers (hereafter referred to as “user data”). With the
                            user identification, SMP Solutions can collect data regarding the user’s
                            utilization of the services through the user ID or placement of cookies,
                            such as IP address, TV channels and broadcasted advertisements. Cookies
                            are small data files, which are stored on the user’s PC and managed by
                            the user’s browser. Cookies enable faster navigation on websites for
                            example, and personalized access. The user can delete and/or prevent the
                            use of cookies on the browser at any time. The user acknowledges and
                            accepts that deleting cookies may limit the performance and quality of
                            the services.
                        </p>
                        <h3 id="3transfertoaffiliatedcompaniesorthirdparties">
                            3. TRANSFER TO AFFILIATED COMPANIES OR THIRD PARTIES
                        </h3>
                        <p>
                            By registering for, or using the services, the user acknowledges and
                            agrees that his relevant personal data and user data is transferred or
                            made accessible to the following companies for the below listed
                            purposes: <br />
                            SMP Solutions GmbH, Platz 3, 6039 Root D4, Switzerland <br />
                            SwissMediaPartners AG, Waaghausgasse 18, 3011, Switzerland <br />
                            In addition, the user agrees that SMP Solutions may transfer the
                            personal data received from the user to third parties as follows: to
                            payment providers (e.g. credit card companies, banks, PayPal, mobile
                            service providers, collection agencies), service providers for creating
                            and preparing statistics, IT service providers (e.g. data centers, host
                            providers, backup services, database services). The aforementioned
                            service providers can only access your personal data to the extent
                            necessary for providing their services. These companies, as well as
                            service providers are obligated to handle the data pursuant to this
                            privacy act declaration and the applicable Privacy Protection Act.
                        </p>
                        <h3 id="4transfertoforeigncountries">4. TRANSFER TO FOREIGN COUNTRIES</h3>
                        <p>
                            The user acknowledges and agrees that relevant personal data is
                            collected and processed in Switzerland, even if the user resides in a
                            different country or utilizes service from a different country. The user
                            acknowledges and agrees that SMP Solutions may transfer and export this
                            data to other countries, including the USA, even if the respective
                            country’s privacy act standards deviate from the Swiss standards or the
                            standards of the user’s country of residence. In this case SMP Solutions
                            shall secure adequate data protection.
                        </p>
                        <h3 id="5useofdata">5. USE OF DATA</h3>
                        <p>
                            <strong>a) UTILIZATION OF SERVICES:</strong> SMP Solutions utilizes
                            relevant personal data for the purpose and the implementation of using
                            SMP Solutions and for payment processing. If the user accesses the
                            services, SMP Solutions determines the IP address to define the country
                            in which the user resides in order to designate the available channels.
                            SMP Solutions may collect and process data relevant to the user’s
                            utilization of services, e.g. IP address, TV channels and advertisements
                            viewed, time and duration of a session, connectivity information and
                            error messages etc. SMP Solutions may also use the data for service
                            utilization and preparing anonymous statistics of user behavior, and
                            forward these statistics to third parties.
                        </p>
                        <p>
                            <strong>b) BILLING AND STATEMENT FOR COPYRIGHT FEES:</strong> If the
                            user subscribes to services subject to charges, SMP Solutions will
                            collect and process the payment information. SMP Solutions entitled to
                            contract third parties payment processing purposes. SMP Solutions
                            utilizes the data concerning the use of services for creating regular
                            reports for the legal owners (e.g. broadcasting facilities,
                            communication companies) regarding the viewer numbers of their contents
                            and for calculating the applicable copyright fees. The reporting
                            includes the aggregated numbers without disclosing the user’s personal
                            data.
                        </p>
                        <p>
                            <strong>c) NEWS AND ADVERTISEMENTS:</strong> SMP Solutions collects and
                            processes address and user data (device used, operating system used,
                            browser type, programs viewed, duration, advertisements viewed) for news
                            and/or promotional messages. SMP Solutions is entitled to pass on
                            personal information about the user (e.g. e-mail address, usage details,
                            etc.) to contract partners in the direct marketing and address brokering
                            field for their handling and promotional use. The user agrees to receive
                            unsolicited third party advertising materials (e.g. advertising from a
                            third party via a promotional e-mail).The user may revoke his consent
                            for the use of his personal data to receive newsletters and/or
                            advertisements at any time. To revoke the consent, the user can click on
                            “unsubscribe” at the end of the newsletter and/or advertisement or
                            revoke the consent in his personal user account. The user agrees that
                            SMP Solutions may send important messages regarding services to the user
                            despite the revocation of consent.
                        </p>
                        <h3 id="6advertisementpersonalizedadvertisement">
                            6. ADVERTISEMENT, PERSONALIZED ADVERTISEMENT
                        </h3>
                        <p>
                            Advertisements may be displayed/”pop up” when utilizing the services or
                            visiting the website. SMP Solutions also displays personalized third
                            party advertisements if the contents are based on the information
                            provided by the user; such as the use of SMP Solutions services or the
                            data disclosed by the user during registration. The advertisement may be
                            provided by contracted third parties. You may update the data in your
                            user account if you do not wish your data to be used for advertisement
                            purposes, this will not affect your ability to use the services provided
                            by SMP Solutions.
                        </p>
                        <h3 id="7coregistration">7. CO-REGISTRATION</h3>
                        <p>
                            In part, SMP Solutions provides an option to its users to register with
                            SMP Solutions partners during the registration process as well. If a
                            user selects a co-registration, SMP Solutions will forward the data
                            provided for the co-registration to its partner, which will then become
                            the owner of this data. SMP Solutions shall explicitly advise the user
                            of the data transfer.
                        </p>
                        <h3 id="8socialnetworks">8. SOCIAL NETWORKS</h3>
                        <p>
                            <strong>a) RECOMMENDATION-BUTTONS:</strong> SMP Solutions provides
                            recommendation buttons for the following social networks on its website:{' '}
                            <br />
                            Facebook-Like-Button <br />
                            Google+-Button <br />
                            Twitter-Recommendation-Button{' '}
                        </p>
                        <p>
                            These buttons enable the user to recommend selected SMP Solutions
                            contents regarding the respective social network to other internet
                            users, add his personal profile in the social network, or bring
                            attention to SMP Solutions contents. The recommendation buttons are
                            provided by the social network operators for the purpose of integrating
                            other websites. By integrating the plugins on SMP Solutions, the
                            operators of the respective social networks may receive the information
                            that the user has accessed the respective SMP Solutions website. If the
                            user is logged in on a social network while visiting SMP Solutions, the
                            network operator may assign a user account to this visit. If such an
                            assignment is not desired, we recommend you log off the social network
                            prior to accessing the SMP Solutions website. If the user utilizes the
                            buttons or comments, the respective information is transferred to, and
                            stored on the corresponding social network. Purpose and extent of data
                            collection, subsequent processing and use of data by social networks, as
                            well as the corresponding rights and setting options to protect your
                            privacy are available in the social network operator’s privacy act
                            information: <br />
                            Facebook Ireland Ltd. and/or Facebook Inc.:
                            http://de-de.facebook.com/policy.php <br />
                            Google Inc.: http://www.google.de/intl/de/privacy/plusone/ <br />
                            Twitter Inc.: http://twitter.com/privacy{' '}
                        </p>
                        <p>
                            <strong>b) LOGIN BY THIRD PARTY PROVIDERS:</strong> SMP Solutions
                            provides an option to log on with your registered SMP Solutions account
                            or with third party accounts you may have registered. This simplifies
                            and speeds up the log on process and also provides you with an option to
                            link SMP Solutions with the third party account and possible other
                            functions to the extent of the third party’s functional scope. Please
                            note that your account settings with third party providers, as well as
                            their privacy act provisions, the scope of data collection, as well as
                            the data third party providers may transfer to us, could deviate. We
                            collect, process and use the data transferred to us exclusively in
                            accordance with this privacy act declaration. However, SMP Solutions can
                            only influence which data the third party provider transfers to SMP
                            Solutions to a limited extent. This is subject to the servitude
                            conditions and privacy act provisions of the applicable third party
                            provider. You may access this information as follows: Facebook:
                            http://de-de.facebook.com/policy.php Google:
                            http://www.google.com/policies/privacy/ Amazon:
                            http://www.amazon.de/gp/help/customer/display.html?ie=UTF8&amp;nodeId=33124019
                        </p>
                        <h3 id="9analysistools">9. ANALYSIS TOOLS</h3>
                        <p>
                            <strong>a) Google Analytics:</strong> Our services use Google Analytics
                            in connection with Google Remarketing. These are programs used for web
                            analysis and target oriented advertising management offered by Google
                            Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA
                            (“Google“). Google uses so called “cookies”; text files, which are
                            stored on the users’ computers or mobile end devices and which enable an
                            analysis for the utilization of our services. The information generated
                            by the cookie regarding the use of our services are generally
                            transferred to, and stored on a Google server in the USA. Within the
                            scope of our services however, we have taken measures to activate IP
                            anonymisation. With this process, the IP addresses of our users have
                            been abbreviated in the European Union member states or other contract
                            states within the Agreement on the European Economic Area by Google.
                            Only in exceptional cases the entire IP address is transferred to a
                            Google server and abbreviated there. Google will use the information
                            transferred on our behalf to analyze the use of our services by users,
                            to create reports regarding the use activity and to provide other
                            services corresponding to the use of our services. These additional
                            services include Google Remarketing. Google Remarketing serves the
                            purpose of us, or third party providers, including Google to activate
                            advertisements on internet websites. When activating advertisements,
                            Google Remarketing enables us to address internet users who have
                            previously used our services. Cookies are utilized for this purpose. The
                            IP addresses transferred within the scope of Google Analytics are not
                            combined with other Google data. You can prevent the storage of cookies
                            with by using the respective setting in your internet browser, however,
                            we advise you that in this case you may not be able to use all functions
                            our services provide to the full extent. You can also prevent the
                            collection of data generated by cookies regarding your use of our
                            services (incl. your IP address) for Google, as well as the data being
                            processed by Google. If you are utilizing our services on a computer on
                            your browser, download the available:
                            https://tools.google.com/dlpage/gaoptout?hl=de. If you are using our
                            services on a mobile end device, you can deactivate the above mentioned
                            data collection process in your settings/privacy act menu for the SMP
                            Solutions app.
                        </p>
                        <h3 id="10datatransferintheeventofamerger">
                            10. DATA TRANSFER IN THE EVENT OF A MERGER
                        </h3>
                        <p>
                            SMP Solutions may purchase or sell subsidiaries or business units. In
                            the event of such transactions, as well as in case of a SMP Solutions
                            take-over, or a substantial part of active SMP Solutions shares, or
                            designated business areas, the relevant personal user data and the user
                            data will generally be part of the active SMP Solutions shares. SMP
                            Solutions reserves the right to include the personal user data in such a
                            potential take-over/merger. The provisions outlined in this privacy act
                            declaration and the applicable privacy act shall also apply to data
                            transferred in the aforementioned circumstances.
                        </p>
                        <h3 id="11righttodisclosure">11. RIGHT TO DISCLOSURE</h3>
                        <p>
                            The user may request information regarding his personal data at SMP
                            Solutions and the correction of incorrect data, as well as the
                            collection of data being ceased and/or data is deleted. Statutory
                            provisions and regulations by governing officials, e.g. courts, which
                            may mandate SMP Solutions storing and making available this personal
                            data are reserved. Disclosure inquiries must be directed to
                            legal@smpsolutions.ch via email, or in written form to SMP Solutions
                            GmbH, Legal Department, Platz 3, 6039 Root, Switzerland. <br />
                            If you would like to delete your account or terminate a paid
                            subscription, you may do so by using our customer menu. SMP Solutions
                            may demand identification verification for information inquiries and
                            deletion requests at any time.
                        </p>
                        <h3 id="12additionalprivacyactdeclarations">
                            12. ADDITIONAL PRIVACY ACT DECLARATIONS
                        </h3>
                        <p>
                            The user is aware that additional privacy act declarations for certain
                            services, e.g. apps, may apply
                        </p>
                        <p>Root, December 2015</p>
                    </div>
                </div>
            </div>
        );
    }
}
